import {Component} from '@angular/core';
import {NavController, Platform} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import { Page } from 'ionic-angular/umd/navigation/nav-util';
import {TeamServiceProvider} from "../../providers/team-service/team-service";
import {ShopListingPage} from "../shop-listing/shop-listing";
import {ShopPage} from "../shop/shop";
import {ShopNewPage} from "../shop-new/shop-new";

import { CoffeShopPage } from '../coffe-shop/coffe-shop';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  loading: boolean;

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    private http: HttpClient,
    private teamProvider: TeamServiceProvider
  ) {
  }

  async ionViewDidEnter() {

    // For the web version of the app we will listen for /#/teams/47
    // If found then we will push the user to the shop view straight away
    console.log("Called : ",this.getTeamIdFromURL());
    
    if (this.getTeamIdFromURL()) {
      const page = await this.detectShopType(this.getTeamIdFromURL());
      this.navCtrl.push(page, {shopId: this.getTeamIdFromURL()});
      return;
    }

    // Multi shops get sent to shop listing page
    if (localStorage.getItem('multiShop')) {
      this.navCtrl.setRoot(ShopListingPage, {});
      return;
    }

    let currentTeamId = localStorage.getItem('currentTeamId');
    let lastBookingTeamId = localStorage.getItem('lastBookingTeamId');

    if (!this.teamProvider.isCustomApp()){

      // If barber is logged in default to their shop
      if (currentTeamId && parseInt(currentTeamId) > 0) {
        const page = await this.detectShopType(currentTeamId);
        this.navCtrl.push(page, {shopId: currentTeamId},{animate:false});
      }

      // If customer has last booking team id set
      if (lastBookingTeamId && parseInt(lastBookingTeamId) > 0) {
        const page = await this.detectShopType(lastBookingTeamId);        
        return this.navCtrl.push(page, {shopId: lastBookingTeamId}, {animate:false});
      }

    } else {

      // If a custom app and a single shop we always fetch the single shop
      this.customApp();

    }

  }
  private async detectShopType(shopId) : Promise<Page> {
    const shop: any = await this.http.get(`/teams/${shopId}`).toPromise();
    if (shop.settings.shop_type === 0) {
      return ShopNewPage;
    }
    if (shop.settings.shop_type === 1) {
      return CoffeShopPage;
    }
  }
  getTeamIdFromURL() {
    let url = window.location.hash.toString();
    let regex = /#\/teams\/([0-9]+)/g;
    let match = regex.exec(url);
    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  customApp() {
    this.loading = true;
    this.teamProvider.getShopLocations().then(async (shops: any) => {
      if (shops.length === 1) {
        localStorage.setItem('singleShop', 'true');
        localStorage.removeItem('multiShop');
        localStorage.removeItem('ownerId');
        const page = await this.detectShopType(this.teamProvider.shopId);
        this.navCtrl.setRoot(page, {shopId: this.teamProvider.shopId});
      }

      if (shops.length > 1) {
        localStorage.setItem('multiShop', 'true');
        localStorage.removeItem('singleShop');
        localStorage.setItem('ownerId', shops[0].owner_id);

        this.navCtrl.setRoot(ShopListingPage, {shops: shops});
      }

      this.loading = false;
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts